<ng-content />

@if (isMobile() && hasMenu()) {
  <button type="button" mat-icon-button class="menuButton noRipple uvMenuToggle" [disableRipple]="true"
    [matMenuTriggerFor]="menu" [attr.aria-label]="'GENERAL.MORE_ACTIONS' | translate">
    <div [innerHTML]="icons()['menu']" class="svg"></div>
  </button>

  <mat-menu #menu="matMenu" xPosition="before">
    @for (action of actions(); track action) {
      <button type="button" mat-menu-item (click)="action.trigger()">
        <span class="rowActionsIcon" [class.iconInfoButton]="!action.warn()" [class.iconDeleteButton]="action.warn()"
          [innerHTML]="action.svg()"></span>
        <span class="linkText">{{ action.label() }}</span>
      </button>
    }
  </mat-menu>
}
